"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pageManager = _interopRequireDefault(require("./page-manager"));
var _bwaCheckoutButton = _interopRequireDefault(require("../components/bwa-checkout-button/bwa-checkout-button"));
var _utils = require("../utils/utils");
var _urlSafety = require("../utils/url-safety");
var _constants = require("../constants/constants");
var _cartGaEventHandler = _interopRequireDefault(require("../events/cart-ga-event-handler"));
var _bwa_checkout_interstitial_loaderWatcher = _interopRequireDefault(require("../events/bwa_checkout_interstitial_loader-watcher"));
var _bwaDeliveryPill = _interopRequireDefault(require("../components/bwa-delivery-pill/bwa-delivery-pill"));
var _checkoutRedirectHandler = require("../utils/checkout-redirect-handler");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CartPage = /*#__PURE__*/function (_PageManager) {
  function CartPage() {
    (0, _classCallCheck2["default"])(this, CartPage);
    return _callSuper(this, CartPage);
  }
  (0, _inherits2["default"])(CartPage, _PageManager);
  return (0, _createClass2["default"])(CartPage, [{
    key: "onPageLoad",
    value: function onPageLoad() {
      new _bwa_checkout_interstitial_loaderWatcher["default"]();
      this.handleCheckoutRedirect();
      _cartGaEventHandler["default"].attachEvents();
      new _bwaCheckoutButton["default"]();
      new _bwaDeliveryPill["default"]();
    }
  }, {
    key: "handleCheckoutRedirect",
    value: function () {
      var _handleCheckoutRedirect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var checkoutRedirectUrl, checkoutId, url, decodedRedirectUrl;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              checkoutRedirectUrl = (0, _utils.getQueryParam)(_constants.QUERY_PARAMS.CHECKOUT_REDIRECT);
              checkoutId = (0, _utils.getQueryParam)(_constants.QUERY_PARAMS.CHECKOUT_ID);
              if (!checkoutRedirectUrl) {
                _context.next = 14;
                break;
              }
              sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_MSHOP_INSTALLED, "false");
              url = new URL(window.location.href);
              url.searchParams["delete"](_constants.QUERY_PARAMS.CHECKOUT_REDIRECT);
              url.searchParams["delete"](_constants.QUERY_PARAMS.CHECKOUT_ID);
              window.history.replaceState(null, '', url.toString());
              decodedRedirectUrl = decodeURIComponent(checkoutRedirectUrl); // Reject disallowed schemes (e.g. javascript: URIs) before any redirect can fire.
              if ((0, _urlSafety.isSafeRedirectUrl)(decodedRedirectUrl)) {
                _context.next = 12;
                break;
              }
              console.error("[BwA] Ignoring unsafe checkout_redirect URL:", decodedRedirectUrl);
              return _context.abrupt("return");
            case 12:
              _context.next = 14;
              return (0, _checkoutRedirectHandler.handleCheckoutValidationAndRedirect)(checkoutId, decodedRedirectUrl);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function handleCheckoutRedirect() {
        return _handleCheckoutRedirect.apply(this, arguments);
      }
      return handleCheckoutRedirect;
    }()
  }]);
}(_pageManager["default"]);
var _default = exports["default"] = CartPage;
//# sourceMappingURL=cart.js.map
